
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import Tree from '@/components/busi/custom/tree.vue'
import util from '@/utils/busi/util'
import { getSubjectBySchoolId } from '@/api/baseinformation'
@Component({
  name: 'school-major-manage',
  components: {
    SimpleTable,
    Tree
  }
})
export default class SchoolMajorManage extends Vue {
  private form: any = {
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'studyName',
    label: '学习类型'
  },
  {
    prop: 'schoolName',
    label: '院校名称'
  },
  {
    prop: 'subjectCode',
    label: '专业代码'
  },
  {
    prop: 'subjectName',
    label: '专业名称'
  },
  {
    prop: 'degreeName',
    label: '学历层次'
  },
  {
    prop: 'lenName',
    label: '学制'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    // do something
    this.loading = !0
    const form = util.trimForm(this.form)
    !pagination && (this.pagination.currentPage = 1)
    await getSubjectBySchoolId({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
    }
    this.onQuery()
  }

  private visible = !1

  private handleNodeClick (data: any) {
    this.form.schoolId = data.id
    this.onQuery()
  }

  mounted () {
    this.onQuery()
  }
}
